import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestChmDetails extends WorkrequestDetailsBase {
  numberOfWaterMeters = 0;
  numberOfRemoteWaterMeters = 0;
  existingMeterDetails: string;
  commonWaterUse = false;
  commonWaterUseDetails: string;
  bodyCorporate: boolean;
  residentialNoCommonWater: boolean;
  commercialNoCommonWater: boolean;
  residentialWithCommonWater: boolean;
  commercialWithCommonWater: boolean;

  constructor() {
    super();
  }

  appendWorkRequestDescription(newCheckMeterLocation: string) {
    this.descriptionOfWork = newCheckMeterLocation;
    let i = 1;
    this.descriptionOfWork += '\r\n';
    this.descriptionOfWork += 'Note: ' + '\r\n';
    if (this.numberOfWaterMeters) {
      this.descriptionOfWork += i + ') Number of 20mm water meters required: ' + this.numberOfWaterMeters + '\r\n';
      i++;
    }
    if (this.numberOfRemoteWaterMeters) {
      this.descriptionOfWork += i + ') Number of 20mm remote water Meters required: ' + this.numberOfRemoteWaterMeters + '\r\n';
      i++;
    }
    if (this.existingMeterDetails) {
      this.descriptionOfWork += i + ') Existing/main boundary water meter details: ' + this.existingMeterDetails + '\r\n';
      i++;
    }
    this.descriptionOfWork += i + ') There is ' + (this.commonWaterUse ? '' : 'no ') + 'common water use at the property\r\n';
    i++;

    if (this.commonWaterUse) {
      this.descriptionOfWork += this.commonWaterUseDetails + '\r\n';
    }

    this.descriptionOfWork += i + ') There is ' + (this.bodyCorporate ? '' : 'no ') + 'body corporate\r\n';
    i++;
    if (this.residentialNoCommonWater ||
      this.commercialNoCommonWater ||
      this.residentialWithCommonWater ||
      this.commercialWithCommonWater) {
      this.descriptionOfWork += i + ') ';
      if (this.residentialNoCommonWater) {
        this.descriptionOfWork += 'Residential units. ALL to be metered no common water.';
      } else if (this.commercialNoCommonWater) {
        this.descriptionOfWork += 'Commercial shops/offices/factories. ALL to be metered no common water.';
      } else if (this.residentialWithCommonWater) {
        this.descriptionOfWork += 'Residential units. ALL to be metered WITH common usage.';
      } else {
        this.descriptionOfWork += 'Commercial shops/offices/factories. ALL to be metered WITH common usage.';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/chm-form/workrequest-chm-details.ts